import Vue from 'vue'
import Vuex from 'vuex'
import { lenovoDataInitState, LenovoDataGetters, lenovoDataMutations } from './modules/m-get-lenovodata.js'
import { selectedData, selectedDataGetters, selectedDataMutations } from './modules/m-get-selectdata.js'
import {boxState, boxStateGetters, boxStateMutations} from './modules/m-get-loadstate'
import {linkManageState, linkManageGetters, linkManageMutations} from './modules/m-get-linkmanage'
import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        lenovoData: lenovoDataInitState,
        selectedData: selectedData,
        cmd: '',
        boxState,
        linkManageState
    },
    getters: {
        ...selectedDataGetters,
        ...LenovoDataGetters,
        ...boxStateGetters,
        ...linkManageGetters
    },
    actions,
    mutations: {
        ...lenovoDataMutations,
        ...selectedDataMutations,
        setCmd(state, data) {
            state.cmd = data;
        },
        ...boxStateMutations,
        ...linkManageMutations
    },
});



// WEBPACK FOOTER //
// ./store/index.js